import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import GuestForm from '../Form';
import { createGuest } from '@resources/Guest/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createGuest, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createGuest(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.guest.create',
						defaultMessage:
							'A new Guest has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.guest',
					defaultMessage: 'Create Guest',
				})}
			</Title>
			<Section className="mb-5">
				<GuestForm onSubmit={handleSubmit} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createGuest,
})(Create);
